<template>
    <div class="lms__superadmin_customer_add">
        <div class="lms__superadmin_customer_add_header">
            <view-actions
                :title="$t('lms.customer.notify.titleNewCustomer')"
                :notify-title="$t('lms.customer.notify.notifyTitle')"
                :notify-process="$t('lms.customer.notify.notifyProcess')"
                :cancel-button-text="$t('lms.customer.notify.cancelButton')"
                :submit-button-active="true"
                :submit-button-text="'Create'"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-event-name="'customer-create'"
                @emit-notify-cancel-submit="customerStopAdd"
                @emit-submit="performSubmitValidate"
            />
        </div>
        <div class="lms__superadmin_customer_add_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar :nav-items="[
                            { label: $t('lms.customer.labels.details'), name: 'lms-superadmin-customer-add-details' },
                            { label: $t('lms.customer.labels.contacts'), name: 'lms-superadmin-customer-add-contacts' },
                            { label: 'Options', name: 'lms-superadmin-customer-add-options' },
                            { label: $t('lms.customer.labels.services'), name: 'lms-superadmin-customer-add-services' },
                            { label: $t('lms.customer.labels.workspaces'), name: 'lms-superadmin-customer-add-workspaces' }
                        ]"></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__superadmin_customer_add_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <pop-notify
            ref="popnotifyvalidation"
            :class="'pop__notify--validation'"
            :title-text="`Something's not quite right`"
            :content-text="'Please check that you have filled out all the fields in the form correctly and try again.'"
            :cancel-button-text="'Ok'"
            :submit-button-active="false"
        />
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'
import PopNotify from '@/components/default/shared/PopNotify'
import { validateBeforeRouteLeave, performSubmitValidate } from '@/helpers/mixins'

export default {
  name: 'lms-superadmin-customer-add',
  components: { PopNotify, ComponentSidebar, ViewActions },
  mixins: [validateBeforeRouteLeave, performSubmitValidate],
  computed: {
    rootItemName () {
      return 'customer'
    },
    nameActionCreate () {
      return 'lmsSuperadminCustomerCreate'
    }
  },
  methods: {
    performSubmitValidateValidationCallback () {
      this.$eventBus.$emit('stop-customer-create')
    },
    performSubmitValidateFinallyCallback () {
      this.$eventBus.$emit('stop-customer-create')
    },
    performSubmitValidateThenCallback () {
      this.customerStopAdd()
    },
    allowRedirectBeforeRouteLeave () {
      this.$eventBus.$emit('customer-submit')
    },
    //
    customerStopAdd () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-customer-list' })
    }
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomeraddedit.scss";
</style>
